import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { StatisticsService } from '@app/services/statistics/statistics.service';

@Component({
  selector: 'app-help-videos-dialog',
  templateUrl: './help-videos-dialog.component.html',
  styleUrls: ['./help-videos-dialog.component.scss']
})
export class HelpVideosDialogComponent implements OnInit {
  videos: any[] = [];
  loading = true;

  constructor(
    public dialogRef: MatDialogRef<HelpVideosDialogComponent>,
    private _statistics: StatisticsService
  ) {}

  ngOnInit(): void {
    this._statistics.onGetDashboardVideos().subscribe({
      next: (res) => {
        if (res != null) {
          this.videos = res.videos;
        }
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
